<template id="salesmanDashboard">
  <section>
    <div
        ref="resizableCard"
        class="card m-1 mr-2 p-0 resizable-card"
        :class="[
    $store.state.bannerStatus ? 'banner-true' : 'banner-false',
    !$store.state.fixedScreen ? 'fixed-screen-width' : ''
  ]"
    >
      <div
          class="resize-handle"
          @mousedown.prevent="startResize"
      >
        ⇲
      </div>
      <b-modal
          v-if="isOpenCoursel"
          id="carouselModal"
          v-model="isOpenCoursel"
          size="xl"
          hide-footer
          hide-header
          hide-backdrop
          no-close-on-esc
          no-close-on-backdrop
          @shown="enableBodyScroll"
          @hidden="restoreBodyScroll"
      >
        <button class="close-cancel-btn" @click="closeCarousel">x</button>
        <!-- Carousel Content -->
        <b-carousel
            id="carousel-1"
            controls
            :indicators="messages.length > 1"
            :interval="0"
            no-wrap
        >
          <b-carousel-slide v-for="(message, index) in messages" :key="index"
                            :style="{ background: message.annonType === 'PresoNote' ? '#c9e0f1' : '#bec7de' }">
            <template #img>
              <div class="carousel-slide-content">
                <h5 v-html="message.annotation"></h5>
                <i class="fas fa-plus-circle add-icon" v-b-tooltip.hover title="Add Note"
                   @click="openEditorToAdd"></i>
                <i class="fas fa-edit edit-icon" v-b-tooltip.hover title="Edit Note"
                   @click="startEditing(index, message)"></i>

                <i
                    class="fa fa-info-circle info-icon"
                    v-b-tooltip.hover.left.html
                    :title=getTooltipContent(message)
                ></i>
              </div>
            </template>
          </b-carousel-slide>

          <b-carousel-slide v-if="messages.length === 0" style="background-color:#c9e0f1">
            <template #img>
              <div class="carousel-slide-content">
                <i class="fas fa-plus-circle add-icon" @click="openEditorToAdd"></i>
              </div>
            </template>
          </b-carousel-slide>
        </b-carousel>
      </b-modal>
      <rich-text-editor
          v-if="isEditorOpen"
          v-model="editedMessage"
          :isOpen.sync="isEditorOpen"
          @save="saveMessage"
          @close="closeEditor"
      >
        <template #custom-content>
          <div v-if="editingIndex===null">
            <label class="mr-3">
              <input :class="{'disabled-label': !menuAnnonAccessControl('PresoNote')}" type="radio"
                     v-model="selectedType" value="PresoNote" :disabled="!menuAnnonAccessControl('PresoNote')">
              PresoNote
            </label>
            <label>
              <input type="radio" v-model="selectedType" value="UserNote"> UserNote
            </label>
            <div v-if="errorMessage" class="text-danger">{{ errorMessage }}</div>
          </div>
        </template>
      </rich-text-editor>
      <div class="card-header d-flex justify-content-between p-0">
        <div class="d-flex flex-wrap justify-content-start">
          <div class="header-left-row">
            <strong class="ml-2">
              <i :class="screenletTitleInfo? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
                 :style="{ color: screenletTitleInfo ? '#ffffff' : 'inherit' }"
                 ref="tooltipIcon"
                 v-b-tooltip.hover.right.html="{ title: screenletTitleInfo, customClass: 'my-custom-tooltip', autoHide: false }"
                 @mouseenter="showTooltip"
                 @mouseleave="hideTooltip">
              </i>
              <span ref="screenNameSpan" v-if="$store.state.deviceType !== 'Mobile'">{{ screenName }}</span>
            </strong>
            <i v-if="Object.entries(screenletListboxDim).length > 0 && $store.state.deviceType !== 'Mobile'" v-b-tooltip.hover.right
               title="Fixed / Flexi-Filter" :class="isToggled ? 'fa fa-toggle-on' : 'fa fa-toggle-off'"
               @click="toggleButtonFunction"
               style="cursor: pointer; margin-left: 10px;"
               aria-hidden="true">
            </i>
            <!-- View Toggle Button -->
            <i v-if="rows.length>1"
                :class="isTabbedView ? 'fas fa-list' : 'fas fa-square'"
                :title="isTabbedView ? 'Tabbed View' : 'Storyboard View'"
                style="font-size: 18px; cursor: pointer; padding-left: 12px;"
                @click="isTabbedView = !isTabbedView; onToggleView()">
            </i>

            <i class="fa-stack fa-md mt-n1 position-relative" @click="openCarousel">
              <!-- Main Icon -->
              <i class="fas fa-comment fa-stack-1x"></i>

              <!-- First Count Circle -->
              <span class="count-circle count-1" :title="`PresoNote Count`">{{ presoAnnonCount }}</span>

              <!-- Second Count Circle -->
              <span class="count-circle count-2" :title="`UserNote Count`">{{ userAnnonCount }}</span>
            </i>
            <div style="display: flex; flex-wrap: wrap; margin-left: 4px" v-if="rows.length > 1 && isToggled && isTabbedView">
              <div style="padding: 0 5px"
                  v-for="(r, index) of rows"
                  :key="'tab-' + r"
                  class="tab-header"
                  :class="{ 'active': activeTab === index }"
                  @click="switchTab(index)"
                  :title="getTooltipText(r, index)"
              >
                <i
                    style="margin-right: 2px"
                    :class="vizletInfoValue(r) ? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
                    :style="{ color: vizletInfoValue(r) ? '#5e8ef4' : 'inherit' }"
                    v-b-tooltip.hover.right.html="{
    title: vizletInfoValue(r),
    customClass: 'my-custom-tooltip1',
    autoHide: false
  }"
                />
                <span style="font-size: 14px">{{vizletShortName(r,index)}} {{ index + 1 }}</span>
              </div>
            </div>

            <div align="left" v-if="isToggled === false">
              <div class="mr-auto p-1 ml-2 d-flex align-items-center">
                <!-- Reset Button -->
                <div v-if="screenletListboxType === 'freeForm' || screenletListboxType === 'anyWhichWay'">
                  <button v-if="filterIsSelected" class="btn-sm btn-outline-danger py-0 px-1" @click="resetLb()">Reset</button>
                </div>

                <!-- Submit Button -->
                <div v-if="isInputFeildFlag === true" style="margin-left: 10px;">
                  <button id="button" class="btn-sm btn-warning py-0 px-1" @click="handleSubmit">Submit</button>
                </div>
              </div>
            </div>
          </div>

          <div v-if="isToggled===false && dateRangeFilterFlag"  class="date-picker-card px-1" >
            {{dateRangeDateFieldLable}}:
            <date-picker
                v-model="time3"
                :shortcuts="shortcuts"
                valueType="format"
                range
                confirm
                placeholder="Select date range"
                @confirm="handleSubmit()"
                @keydown.enter.prevent="onEnterSubmit"
                @clear="handleSubmit()"
            />
          </div>
          <div v-for="(item, idx) of screenletListboxDim" :key="idx" >
            <!-- Text input for fields marked as inputField -->
            <div v-if="item.isInputField && isToggled===false" class="mr-auto px-1">
              <span>{{ SLlistboxDimBizName[idx] }}:</span>
              <input
                  type="text"
                  :value="getFilterValue(item.name)"
                  @input="updateFilter(item.name, $event.target.value)"
                  class="input-feild"
                  placeholder="Enter Value"
              />
            </div>

            <!-- Multiselect for regular fields when not toggled -->
            <div v-if="!item.isInputField && isToggled===false" class="mr-auto px-1">
              <span>{{ SLlistboxDimBizName[idx] }}:</span>
              <div class="anyWhichWay" v-if="screenletListboxType === 'anyWhichWay'">
                <multiselect
                    :ref="`multiselect-${item.name}`"
                    v-model="filter[item.name]"
                    :options="getOptionsWithSelectAll(item.name)"
                    :multiple="true"
                    :limit="1"
                    :class="{ 'border-error': listboxError[item.name] }"
                    select-label="Select"
                    deselect-label="Unselect"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :append-to-body="true"
                    :clear-on-close="true"
                    track-by="value"
                    label="label"
                    class="compact-multiselect"
                    @input="handleOptionSelected(item.name, $event)"
                    @select="onSelect(item.name, $event)"
                    :open="isOpen"
                    style="min-height: 20px"
                    @remove="onRemove(item.name, $event)"
                    @close="onSelectOption(item.name)"
                >
                  <template v-slot:option="{ option }">
                    <label
                        v-if="option.value === selectAllValue"
                        class="custom-option"
                        :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                      />
                      {{ option.label }}
                    </label>
                    <label
                        v-else
                        class="custom-option"
                        @click.prevent="isOptionSelected(item.name, option.value)"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                          @click.stop
                      />

        {{ option.label }}

                    </label>
                  </template>
                  <template v-slot:afterList>
                    <div class="multiselect-footer">
                      <button class="btn-sm btn-success" type="button" @click="handleSubmit(item.name)">SUB</button>
                      <button class="btn-sm btn-primary" type="button" @click="onSelectOption(item.name)">SEL</button>
                      <button class="btn-sm btn-secondary" type="button" @click="onClearClick(item.name)">CLR</button>
                      <button class="btn-sm btn-light" type="button" @click="onCancelClick(item.name)">X</button>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="freeForm" v-else>
                <multiselect
                    :ref="`multiselect-${item.name}`"
                    v-model="filter[item.name]"
                    :options="getOptionsWithSelectAll(item.name)"
                    :multiple="true"
                    :limit="1"
                    select-label="Select"
                    deselect-label="Unselect"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :append-to-body="true"
                    :clear-on-close="true"
                    track-by="value"
                    label="label"
                    class="compact-multiselect"
                    @input="handleOptionSelected(item.name, $event)"
                    @select="onSelect(item.name, $event)"
                    @open="isOpen = true"
                    @close="isOpen = false"
                    style="min-height: 20px"
                    @remove="onRemove(item.name, $event)"
                >
                  <template v-slot:option="{ option }">
                    <label
                        v-if="option.value === selectAllValue"
                        class="custom-option"
                        @click.prevent="isOptionSelected(item.name, option)"
                        :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                      />
                      {{ option.label }}
                    </label>
                    <label
                        v-else
                        class="custom-option"
                        @click.prevent="isOptionSelected(item.name, option.value)"
                    >
                      <input
                          type="checkbox"
                          :checked="isOptionSelected(item.name, option.value)"
                          @change="handleCheckboxChange(item.name, option.value, $event)"
                          @click.stop
                      />

                      {{ option.label }}

                    </label>
                  </template>
                  <template v-slot:afterList>
                    <div class="multiselect-footer">
                      <button class="btn-sm btn-success" type="button" @click="handleSubmit(item.name)">Ok</button>
                      <button class="btn-sm btn-danger " type="button" @click="onClearClick(item.name)">Clear</button>
                      <button class="btn-sm btn-warning " type="button" @click="onCancelClick(item.name)">Cancel</button>

                    </div>
                  </template>
                </multiselect>

              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-sm-between" style="align-items: center">
        <!-- parent header override when single viz -->
        <vizlet-header
            v-if="rows.length === 1"
            :viz1="activeViz.viz1"
            :currentMenuActionIconsData="activeViz.currentMenuActionIconsData"
            :mCurrentMenuActionIconsData="activeViz.mCurrentMenuActionIconsData"
            :iconOnChangeFlag="iconOnChangeFlag"
            :vizCount="rows.length"
            :searchQuery.sync="searchQuery"
            :isCollapsed="childIsCollapsed"
            :format="parentOnFormat"
            :total="activeVizTotal"
            @toggle-body="parentOnToggleBody"
            @toggle-width="parentOnToggleWidth"
            @action="parentOnAction"
            @reset-filter="parentOnResetFilter"
            @search="parentOnSearch"
        />

        <div v-if="Object.entries(screenletListboxDim).length > 0 && isToggled" class="p-1">
          <button @click="showFilterDialog" class="btn btn-sm py-0 px-1"
                  v-bind:class="{'btn-primary': filterIsSelected, 'btn-info': !filterIsSelected}">
            <span style="font-size: .7rem"><i class="fas fa-filter"></i></span>
            <span class="ml-1" v-if="!filterIsSelected">Filter</span>
            <span class="ml-1" v-else>{{ filterCount }}<span v-if="$store.state.deviceType !== 'Mobile'"> Filter(s) Applied</span></span>
          </button>
        </div>
        </div>
      </div>
      <div class="card-body" v-if="loadViz">
        <div class="body-div" v-if="isTabbedView">
          <div class="viz-tabs-container">
            <!-- Tab Headers -->
            <div class="tab-headers" v-if="rows.length > 1 && isToggled===false">
              <div
                  style="padding: 0 5px"
                  v-for="(r, index) of rows"
                  :key="'tab-' + r"
                  class="tab-header"
                  :class="{ 'active': activeTab === index }"
                  @click="switchTab(index)"
                  :title="getTooltipText(r, index)"
              >
                <i
                    style="margin-right: 2px"
                    :class="vizletInfoValue(r) ? 'fa fa-info-circle custom-icon' : 'fa fa-info-circle'"
                    :style="{ color: vizletInfoValue(r) ? '#5e8ef4' : 'inherit' }"
                    v-b-tooltip.hover.right.html="{
    title: vizletInfoValue(r),
    customClass: 'my-custom-tooltip1',
    autoHide: false
  }"
                />

                <span style="font-size: 14px">{{vizletShortName(r,index)}}  {{ index + 1 }}</span>
              </div>
            </div>
          <div
              v-bind:class="[
              screenletCardClass,
              screenletCardStyle === 'flex-row-overflowX' ? 'flex-row-overflowX-style' : '',
              screenletCardStyle === 'flex-row-overflowY' ? 'flex-row-overflowY-style' : ''
          ]">
            <viz1
                @refresh="handleRefresh"
                v-if="rows.length > 0 && rows[activeTab] !== undefined"
                ref="childComponent"
                :key="rows[activeTab]"
                :propTime="propTime"
                :viz1="vizDataRowCol[screenlet][rows[activeTab]]"
                :screenlet="screenlet"
                :width="cardWidth"
                :height="cardHeight"
                :vizCount="rows.length"
                :filterFlag="submitSelectedFilter"
                :headerHeight="headerHeight"
                :filterParam="vizFilterParams"
                @viz-loaded="handleVizLoaded"
            ></viz1>
          </div>
          </div>
        </div>
        <div class="body-div" v-if="isTabbedView===false">
          <div
              v-bind:class="[
              screenletCardClass,
              screenletCardStyle === 'flex-row-overflowX' ? 'flex-row-overflowX-style' : '',
              screenletCardStyle === 'flex-row-overflowY' ? 'flex-row-overflowY-style' : ''
          ]">
            <viz1  @refresh="handleRefresh" v-for="r of rows" v-bind:key="r" ref="childComponent" :propTime="propTime"
                  :viz1="vizDataRowCol[screenlet][r]" :screenlet="screenlet" :width="cardWidth"
                  :height="cardHeight" :vizCount="rows.length" :filterFlag="submitSelectedFilter"
                  @viz-loaded="handleVizLoaded" :filterParam="vizFilterParams"></viz1>
          </div>
        </div>
      </div>

      <dialog ref="dialog">
        <input ref="hiddenInput" type="text" style="position: absolute; opacity: 0;width: 0">
        <div class="d-flex flex-column h-100">
          <button @click="hideFilterDialog" class="btn btn-outline"
                  style="position: absolute; right: 10px; top: 30px;font-size: small; background-color: white">
            X
          </button>
          <h5 class="text-left mb-2 pb-2" style="border-bottom: 1px solid #ccc">Filters for {{ screenName }}</h5>
          <div>
            <common-alert
                :is-visible="showAlert"
                :dismiss-secs="7"
                message="This Menu Requires a Pre Selection Filter,Please Choose."
                variant="warning"
                @dismissed="onAlertDismissed"
            />
          </div>
          <common-alert
              :is-visible="showError"
              :dismiss-secs="60"
              message="Please select at least one filter."
              variant="warning"
              @dismissed="onAlertDismissed"
          />
          <div class="flex-grow-1 mb-3" style="overflow-y: auto; overflow-x: hidden">
            <div class="row">
              <div class="date-picker-dialog-card col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column" v-if="dateRangeFilterFlag">
                <p style="margin: 0;">{{dateRangeDateFieldLable}}</p>
                <date-picker
                    v-model="time3"
                    :shortcuts="shortcuts"
                    valueType="format"
                    :append-to-body="false"
                    range
                    confirm
                    placeholder="Select date range"
                />
              </div>
              <div v-for="(item,idx) of screenletListboxDim" :key="idx"
                   class="col-12 col-sm-6 col-md-4 p-2 px-4 d-flex flex-column">
                <span class="text-left" style="font-size: .8rem; font-weight: bold">{{
                    SLlistboxDimBizName[idx]
                  }}</span>

                <input v-if="item.isInputField"
                       type="text"
                       :value="getFilterValue(item.name)"
                       @input="updateFilter(item.name, $event.target.value)"
                       class="form-control"
                       placeholder="Enter Value"
                />
                <div v-else>
                  <div class="anyWhichWay" v-if="screenletListboxType === 'anyWhichWay'">
                    <multiselect
                        v-model="filter[item.name]"
                        :options="getOptionsWithSelectAll(item.name)"
                        :multiple="true"
                        :limit="1"
                        select-label="Select"
                        deselect-label="Unselect"
                        :close-on-select="false"
                        :clear-on-select="true"
                        :clear-on-close="true"
                        :append-to-body="true"
                        track-by="value"
                        label="label"
                        @input="handleOptionSelected(item.name, $event)"
                        @select="onSelect(item.name, $event)"
                    >
                      <template v-slot:option="{ option }">
                        <label
                            v-if="option.value === selectAllValue"
                            class="custom-option"
                            :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                        >
                          <input
                              type="checkbox"
                              :checked="isOptionSelected(item.name, option.value)"
                              @change="handleCheckboxChange(item.name, option.value, $event)"
                          />
                          {{ option.label }}
                        </label>
                        <label
                            v-else
                            class="custom-option"
                            @click.prevent="isOptionSelected(item.name, option.value)"
                        >
                          <input
                              type="checkbox"
                              :checked="isOptionSelected(item.name, option.value)"
                              @change="handleCheckboxChange(item.name, option.value, $event)"
                              @click.stop
                          />

                          {{ option.label }}

                        </label>
                      </template>
                    </multiselect>
                  </div>
                  <div class="freeForm" v-else>
                    <multiselect
                        v-model="filter[item.name]"
                        :options="getOptionsWithSelectAll(item.name)"
                        :multiple="true"
                        :limit="1"
                        select-label="Select"
                        deselect-label="Unselect"
                        :close-on-select="false"
                        :clear-on-select="false"
                        :clear-on-close="true"
                        :append-to-body="true"
                        track-by="value"
                        label="label"
                        @input="handleOptionSelected(item.name, $event)"
                        @select="onSelect(item.name, $event)"
                    >
                      <template v-slot:option="{ option }">
                        <label
                            v-if="option.value === selectAllValue"
                            class="custom-option"
                            :class="{ 'disable-parent-click': !isOptionSelected(item.name, option.value) }"
                        >
                          <input
                              type="checkbox"
                              :checked="isOptionSelected(item.name, option.value)"
                              @change="handleCheckboxChange(item.name, option.value, $event)"
                          />
                          {{ option.label }}
                        </label>
                        <label
                          v-else
                          class="custom-option"
                          @click.prevent="isOptionSelected(item.name, option.value)"
                      >
                        <input
                            type="checkbox"
                            :checked="isOptionSelected(item.name, option.value)"
                            @change="handleCheckboxChange(item.name, option.value, $event)"
                            @click.stop
                        />

                        {{ option.label }}

                      </label>
                      </template>
                    </multiselect>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="d-flex justify-content-end">
            <button id="button" class="btn-sm btn-success"
                    @click="handleSubmit"> Submit
            </button>
            <button class="btn btn-sm ml-2 text-warning border border-warning" @click="resetLb()" title="Reset"
                    style="background-color: transparent;">
              Clear <i class="fas fa-times-circle"></i>
            </button>
          </div>
        </div>
      </dialog>
      <div>
        <common-alert
            :is-visible="invalidMenuAlert"
            :dismiss-secs="7"
            message="Invalid Menu ,redirecting to Home Page."
            variant="warning"
            @dismissed="onAlertDismissed"
        />
      </div>
      <div v-if="isDialogOpened">
        <common-alert
            :is-visible="showError"
            :dismiss-secs="7"
            message="This Menu Requires a Pre Selection Filter,Please Choose."
            variant="warning"
            @dismissed="onAlertDismissed"
        />
      </div>
    </div>
  </section>
</template>
<script>
import Viz1 from '@/components/vizlet'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import _ from 'lodash'
import axios from 'axios';
import Multiselect from 'vue-multiselect/src/Multiselect'
import CommonAlert from '@/components/CommonAlert.vue'
import RichTextEditor from "@/components/RichTextEditor.vue";
import {isDescendant} from "@/common/functions";
import {apiAbort} from "@/common/apiAbort";
import VizletHeader from "@/components/VizletHeader.vue";

export default {
  name: "salesmanDashboard",

  components: {VizletHeader, Viz1, DatePicker, Multiselect, CommonAlert, RichTextEditor},
  props: {
    screenlet: Number,
    sl: Object,
    scrnPropTime: Date,
    screenletId: String,
    passedParam:Object
  },
  watch: {
    $props: {
      async handler() {
        console.log("props changed")
        await this.targetPage();
        await this.loadListbox();
      },
      deep: true,
      immediate: true,
    },
    // screenletListboxDim: {
    //   handler() {
    //    this.initializeDefaultSelections()
    //   },
    //   immediate: true,
    //   deep: true
    // },
    "clickedFilters": {
      handler() {
        if (Object.keys(this.clickedFilters).length > 0) {
          this.filter = {...this.clickedFilters, ...this.globalFilters};
          // console.log("watch globalFilters", this.filter);
        }
      },
      immediate: true,
      deep: true
    },
    "$store.state.annotations": {
      immediate: true, // Trigger the watcher immediately
      handler() {
        this.processAnnotations();
      },
    },
    selectedType(newValue) {
      if (newValue) {
        this.errorMessage = ""; // Clear error when user selects a value
      }
    },
    rows: {
      immediate: true,
      handler(newRows) {
        this.totalVizCount = newRows.length;
        this.loadedVizCount = 0; // Reset counter when rows change
      }
    },
    'activeViz.currentMenuActionIconsData': {
      immediate: true,
      handler(list) {
        const len = Array.isArray(list) ? list.length : 0;
        this.iconOnChangeFlag = Array(len).fill(true);
      }
    }
,
  },
  data: () => ({
    loadedVizCount: 0,
    totalVizCount: 0,
    optionValues: ['a', 'b'],
    loadViz: false,
    menuPath: '',
    filterValues: [],
    searching: false,
    vizData: [],
    vizDataRowCol: {},
    screenName: '',
    time3: '',
    rows: [],
    x: {},
    filter: {},
    selectedOption: {},
    listboxError: {},
    //x: {"d3l1_name":"All","d6l1_name":"All"},//need to revisit to make it dynamic
    propTime: null,
    y: {},
    li: 0,
    screenletListboxCount: null,
    screenletListboxCountT: 2,
    orderbyTextJson: {},
    screenletListboxDim: {},
    screenletListboxInputField: {},
    dateRangeFilterFlag: '',
    SLlistboxDimBizName: {},
    currentMenuActionIconsData: {},
    currentMenuListboxData: {},
    dateRangeFilterShortcuts: {},
    dateRangeDateField: {},
    dateRangeDateFieldLable: '',
    shortcuts: [],
    temp: [],
    promises: [],
    rowColMap: {},
    selectedKey: null,
    selectedValue: null,
    dataset: [],
    screenletListboxType: null,
    br: null,
    sm: null,
    data: [
      {label: '0'},
      {label: '2'},
      {label: '3'},
      {label: '8'},
      {label: '9'},
      {label: '11'},
      {label: '13'},
      {label: '14'},
      {label: '15'},
      {label: '18'}
    ],
    filters: [{
      nameAll: 'Select all',
      nameNotAll: 'Deselect all',
      func() {
        return true;
      },
    }],
    options: {
      multi: true,
      groups: false,
      labelName: 'label',
      labelList: 'elements',
      groupName: 'title',
      cssSelected: option => (option.selected ? {'background-color': '#5764c6'} : ''),
    },
    screenletListboxDefault: {},
    screenletCardStyle: '',
    screenletTitleInfo: '',
    listBoxOptions: {},
    listBoxCache: {},
    filterOptions: {},
    filtersArray: [],
    dataFiltersArray: [],
    selectedFilters: {},
    selectedListboxFilters: {},
    showAlert: false,
    listBoxOption2: {},
    isToggled: false,
    invalidMenuAlert: false,
    messages: [],
    isOpenCoursel: false,
    editingIndex: null, // Track which message is being edited
    editedMessage: '',// Store the edited message temporarily
    isEditorOpen: false,
    selectedType: '',
    errorMessage: '',
    presoAnnonCount: 0,
    userAnnonCount: 0,
    showError: false,
    isDialogOpened: true,
    globalFilters: {},
    clickedFilters: {},
    showResize: false,
    isResizing: false,
    startWidth: 0,
    startHeight: 0,
    startX: 0,
    startY: 0,
    cardWidth: 0,
    cardHeight: 0,
    submitSelectedFilter:false,
    selectAllValue: 'All',
    isOpen: false,
    headerHeight:0,
    title:"",
    activeTab: 0, // Always start with first tab
    isTabbedView: false,
    searchQuery: '',
    childIsCollapsed: false,
    iconOnChangeFlag: [],
    vizFilterParams: {},
    openDropdown: {},
    isInputFeildFlag:false
  }),
  computed: {
    activeViz() {
      const rows = this.rows || [];
      if (!rows.length) return {
        viz1: {},
        currentMenuActionIconsData: [],
        mCurrentMenuActionIconsData: []
      };

      const actionIconsData = this.$store.state.actionIcons || [];
      const viz1 = (this.vizDataRowCol[this.screenlet] || {})[rows[this.activeTab]] || {};

      const vizletActionIconsSyspkArray = viz1.vizletActionIconsSyspkArray || [];
      const mvizletActionIconsSyspkArray = viz1.mvizletActionIconsSyspkArray || [];

      // filter
      const currentMenuActionIconsData = actionIconsData.filter(r => vizletActionIconsSyspkArray.includes(r.syspk));
      const mCurrentMenuActionIconsData = actionIconsData.filter(r => mvizletActionIconsSyspkArray.includes(r.syspk));

      // sort by reference array order
      const sortFuncAI = (a, b) => vizletActionIconsSyspkArray.indexOf(a.syspk) - vizletActionIconsSyspkArray.indexOf(b.syspk);
      const msortFuncAI = (a, b) => mvizletActionIconsSyspkArray.indexOf(a.syspk) - mvizletActionIconsSyspkArray.indexOf(b.syspk);

      currentMenuActionIconsData.sort(sortFuncAI);
      mCurrentMenuActionIconsData.sort(msortFuncAI);
      return {
        viz1,
        currentMenuActionIconsData,
        mCurrentMenuActionIconsData
      };
    },
    // active viz object used to populate header props
    activeVizTotal() {
      const v = this.activeVizObj;
      return v ? (v.total || 0) : 0;
    },
    isAnyFilterSelected() {
      return Object.values(this.filter).some(value => {
        if (Array.isArray(value)) {
          return value.length > 0 && value.some(item => item !== null && item !== undefined && item !== '');
        } else if (typeof value === 'string') {
          return value.trim() !== ''; // Check if the string is not empty
        } else {
          return value !== undefined && value !== null; // Check if the value is not undefined or null
        }
      });
    },
    filterCount() {
      // eslint-disable-next-line no-unused-vars
      return Object.entries(this.filter).filter(([k, v]) => {
        if (Array.isArray(v)) {
          return v.some(val => val != null);  // Only count if there's a valid value
        } else {
          return v != null;  // Only count if non-null and non-undefined
        }
      }).length
    },
    filterIsSelected() {
      return this.filterCount > 0
    },
    getFilteredValues() {
      return (key1) => {
        // console.log("key1", key1)
        // console.log(this.dataset)

        // get unique sorted values
        const distinctValues = _.uniq(this.dataset.map(kv => kv[key1]))
            .sort((a, b) => {
              const isDateA = this.isDateRelated(a);
              const isDateB = this.isDateRelated(b);

              if (isDateA && isDateB) {
                // Both are date-related, sort in descending order
                return this.parseDate(b) - this.parseDate(a);
              }
              // fallback to normal string compare
              return String(a).localeCompare(String(b));
            });

        // map into {value, label} format
        const options = distinctValues.map(opt => ({
          value: opt,
          label: opt,
        }));

        // prepend Select All
        return [{value: this.selectAllValue, label: "Select All"}, ...options];
      };

    },
    screenletCardClass() {
      if (this.screenletCardStyle === 'card-deck') {
        return 'card-deck m-1'
      } else if (this.screenletCardStyle === 'flex-row-overflowY') {
        return 'd-flex flex-row m-1'
      } else if (this.screenletCardStyle === 'flex-no-wrap') {
        return 'm-1'
      } else {
        return 'card-deck m-1'
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    applyScreenletListboxDefault() {
      let defaultValues = {}; // Initialize an object to store the default values
      if (this.screenletListboxDefault) {
        if (Object.keys(this.screenletListboxDefault).length > 0) {
          Object.keys(this.screenletListboxDefault).forEach((key) => {
            /*
            console.log("listBoxOptions", JSON.stringify(this.listBoxOptions));
            console.log("screenletListboxDefault", this.screenletListboxDefault[key]);*/
            defaultValues[key] = this.screenletListboxDefault[key]; // Populate the defaultValues object
          });
        }
      }
      return defaultValues;
    },
  },
  async created() {
    const menuTree = this.$store.state.menuMasterData.filter(m => m.parentMenuId === 'Root') || []
    // console.log("banner flag", this.$store.state.bannerStatus)

    let restrictedMenu = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
    let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || [];

    // Handle empty/undefined/null/["[]"] cases - all menus allowed
    const isAllMenusAllowed = !restrictedMenu ||
        restrictedMenu.length === 0 ||
        (restrictedMenu.length === 1 && restrictedMenu[0] === "[]")

    if (!isAllMenusAllowed) {
      const currentMenuId = this.$route.params.menuId
      const currentSubmenuId = this.$route.params.submenuId

      // Only check menu restrictions for routes that have these parameters
      if (currentMenuId || currentSubmenuId) {
        // Check if current IDs are in exclusion array
        const isExcluded = exclusionArray.includes(currentMenuId) ||
            exclusionArray.includes(currentSubmenuId)
        // If NEITHER menuId NOR submenuId is in the allowed list, block access
        // Check whether current IDs are directly allowed or descendants of allowed ones
        const isAllowed =
            restrictedMenu.includes(currentMenuId) ||
            restrictedMenu.includes(currentSubmenuId) ||
            isDescendant(menuTree, restrictedMenu, currentMenuId) ||
            isDescendant(menuTree, restrictedMenu, currentSubmenuId);

        if (!isAllowed || isExcluded) {
          window.alert("Invalid action, request please contact your Administrator")
          // You might want to redirect to user-restrict page here as well
          await this.$router.push('/user-restrict')
          return; // Stop execution
        }
      }
    }

    this.listenToRouter()
    this.filter = {...this.screenletListboxDefault}
  },
  mounted() {
    // const headerEl = this.$el.querySelector(".card-header");
    // if (headerEl) {
    //   // Create observer
    //   this.headerObserver = new ResizeObserver(entries => {
    //     for (let entry of entries) {
    //       // this.headerHeight = entry.contentRect.height;
    //      // console.log("Card header height:", this.headerHeight);
    //     }
    //   });
    //   this.headerObserver.observe(headerEl);
    // }
    this.onWindowResize()
    window.addEventListener('resize', this.onWindowResize);
  },
  // beforeUnmount() {
  //   if (this.headerObserver) {
  //     this.headerObserver.disconnect();
  //   }
  // },
  methods: {
    onSelectOption(fieldName) {
      const current = this.filter[fieldName] || []
      const selected = this.selectedOption[fieldName] || []

      const currentValues = current.map(o => o.value).sort()
      const selectedValues = selected.map(o => o.value).sort()

      console.log("currentValues",currentValues)
      console.log("currentValues",selectedValues)

      const isMismatch =
          currentValues.length !== selectedValues.length ||
          JSON.stringify(currentValues) !== JSON.stringify(selectedValues)

      // set border state ONLY here
      this.$set(this.listboxError, fieldName, isMismatch)

      const ref = this.$refs[`multiselect-${fieldName}`]
      if (ref && ref[0]) {
        ref[0].deactivate()
      }

      // Optional: if match, persist selection
      /*if (!isMismatch) {
        this.$set(this.selectedOptions, fieldName, [...current])
      }*/
    },
    onClearClick(fieldName) {
      const currentValue = this.filter[fieldName]

      console.log("clear listbox", currentValue)
      console.log("clear listbox", currentValue.length)

      // Do nothing if already empty or not an array
      if (!Array.isArray(currentValue) || currentValue.length === 0) {
        return
      }

      // Clear only if there were values
      this.$set(this.filter, fieldName, [])


      // Submit only when something was actually cleared AND menuPath is not '/post-load'
      // if (this.menuPath !== '/post-load') {
      //   this.$nextTick(() => {
      //     this.handleSubmit(fieldName)
      //   })
      // }
    },

    onRemove(fieldName, removedOption) {
      // Remove ONLY the clicked option
      this.filter[fieldName] = this.filter[fieldName].filter(
          opt => opt.value !== removedOption.value
      )

      console.log("=== Removed Option Details ===")
      console.log("Full object:", removedOption)

      const ref = this.$refs[`multiselect-${fieldName}`]
      if (ref) {
        // when ref is an array (v-for case)
        const multiselect = Array.isArray(ref) ? ref[0] : ref
        multiselect.activate()
      }

      // // Check if 'value' property is a getter/setter
      // const descriptor = Object.getOwnPropertyDescriptor(removedOption, 'value')
      // const isGetterSetter = descriptor && (descriptor.get || descriptor.set)
      //
      // console.log("Property descriptor for 'value':", descriptor)
      // console.log("Is getter/setter?", isGetterSetter)
      //
      //

      // // Only call handleSubmit if it's a Getter & Setter object AND menuPath is not '/post-load'
      // if (isGetterSetter && this.menuPath !== '/post-load') {
      //   console.log("This is a Getter & Setter object - calling handleSubmit")
      //   this.$nextTick(() => {
      //     this.handleSubmit(fieldName)
      //   })
      // } else {
      //   console.log("This is a regular object - NOT calling handleSubmit")
      // }
    },
    handleRefresh(){
      this.loadListbox();
    },
    onEnterSubmit() {
      // Ensure value exists before submitting
      if (this.time3 && this.time3.length === 2) {
        this.$nextTick(() => {
          setTimeout(() => {this.handleSubmit()},200);
          })
      }
    },
    onToggleView() {
      console.log("tab", this.isTabbedView)
      this.activeTab = 0

      if (!this.isTabbedView) {
        this.handleSubmit();
      }
    },
    // Helper method to get the child component
// Since icons only show when rows.length === 1, we always have at most one child
    getChildRef() {
      // Debug: check what we have
      console.log('getChildRef - $refs.childComponent:', this.$refs.childComponent);
      console.log('rows.length:', this.rows.length);

      if (!this.$refs.childComponent) {
        console.warn('No childComponent ref found');
        return null;
      }

      // Since icons only show when rows.length === 1, handle both cases:
      if (this.rows.length === 1) {
        // Single child - could be an array (if v-for rendered) or single ref
        if (Array.isArray(this.$refs.childComponent)) {
          // Get the first (and only) element
          return this.$refs.childComponent[0] || null;
        }
        // Single ref
        return this.$refs.childComponent;
      }

      // Should not reach here if icons are properly hidden when rows.length > 1
      console.warn('getChildRef called but rows.length > 1');
      return null;
    },

// Forwarders: called when parent header emits events
    parentOnToggleBody() {
      // Only applicable when rows.length === 1
      if (this.rows.length !== 1) return;

      const childRef = this.getChildRef();
      console.log('parentOnToggleBody - childRef:', childRef);

      if (childRef && typeof childRef.toggleCardBody === 'function') {
        childRef.toggleCardBody();
        // sync local collapsed state if needed
        this.childIsCollapsed = childRef.isCollapsed !== undefined ?
            childRef.isCollapsed :
            !this.childIsCollapsed;
      } else {
        // fallback
        this.childIsCollapsed = !this.childIsCollapsed;
        console.warn('toggleCardBody method not found on child');
      }
    },

    parentOnFormat() {
      // Only applicable when rows.length === 1
      if (this.rows.length !== 1) return;

      const childRef = this.getChildRef();
      console.log('parentOnFormat - childRef:', childRef);

      if (childRef && typeof childRef.format === 'function') {
        // Note: Fixed method name - you had toggleCardWidth but calling format()
        childRef.format();
      } else {
        console.warn('format method not found on child');
      }
    },

    parentOnToggleWidth() {
      // Only applicable when rows.length === 1
      if (this.rows.length !== 1) return;

      const childRef = this.getChildRef();
      console.log('parentOnToggleWidth - childRef:', childRef);

      if (childRef && typeof childRef.toggleCardWidth === 'function') {
        childRef.toggleCardWidth();
      } else {
        console.warn('toggleCardWidth method not found on child');
      }
    },

    parentOnAction(functionName, index, ai) {
      // Only applicable when rows.length === 1
      if (this.rows.length !== 1) return;

      const childRef = this.getChildRef();
      console.log('parentOnAction - childRef:', childRef);

      if (childRef && typeof childRef.handleActionIconFunctionCall === 'function') {
        childRef.handleActionIconFunctionCall(functionName, index, ai);

        if (Array.isArray(childRef.iconOnChangeFlag)) {
          this.iconOnChangeFlag = [...childRef.iconOnChangeFlag];
        }
      } else {
        console.error('handleActionIconFunctionCall method not found on child', {
          childRef,
          hasMethod: childRef && typeof childRef.handleActionIconFunctionCall
        });
      }
    },

    parentOnResetFilter() {
      // Only applicable when rows.length === 1
      if (this.rows.length !== 1) return;

      const childRef = this.getChildRef();
      console.log('parentOnResetFilter - childRef:', childRef);

      if (childRef && typeof childRef.resetFilter === 'function') {
        childRef.resetFilter();
      } else {
        console.warn('resetFilter method not found on child');
      }
    },

    parentOnSearch(q) {
      // Only applicable when rows.length === 1
      if (this.rows.length !== 1) return;

      const childRef = this.getChildRef();
      console.log('parentOnSearch - childRef:', childRef);

      if (childRef && typeof childRef.handleSearch === 'function') {
        childRef.handleSearch(q);
      } else {
        // fallback: keep parent's searchQuery for any parent-level filtering
        this.searchQuery = q;
        console.warn('handleSearch method not found on child');
      }
    },
    getTooltipText(row) {
      console.log("row",this.vizDataRowCol[this.screenlet][row])
      // Customize this based on what data you want to show
      return this.vizDataRowCol[this.screenlet][row].vizletTitleDpName;
    },
    vizletShortName(row) {
      try {
        return this.vizDataRowCol[this.screenlet][row].vizletTitleDpShortName;
      } catch (error) {
        console.error('Error getting vizlet short name:', error);
      }

      // Default fallback
      return 'Viz';
    },

    vizletInfoValue(row) {
      try {
        console.log("vizletTitleInfo",this.vizDataRowCol[this.screenlet][row])
        return this.vizDataRowCol[this.screenlet][row].vizlet_title_info;
      } catch (error) {
        console.error('Error getting vizlet Title Info:', error);
      }

      // Default fallback
      return 'Viz';
    },
    switchTab(index) {
      this.activeTab = index;
    },
    onCancelClick(itemName) {
      this.$set(this.openDropdown, itemName, false)
      const ref = this.$refs[`multiselect-${itemName}`]
      if (ref && ref[0]) {
        ref[0].deactivate()
      }
    },
    handleVizLoaded() {
      this.loadedVizCount++;

      // Check if all child components have completed loading
      if (this.loadedVizCount === this.totalVizCount) {
        this.$store.commit('setFilterFlag', false);
        // console.log("All viz iterations completed", this.$store.state.filterFlag);

        // Reset counter for next time
        this.loadedVizCount = 0;
      }
    },
    onSelect(key, option) {
      if (option.value === this.selectAllValue) {
        // Trigger same logic as label click
        this.handleCheckboxChange(key, option.value, { target: { checked: true } });
      }
    },
    // Get options for multiselect, including "Select All"
    getOptionsWithSelectAll(key) {
      const options = (this.listBoxOptions[key] || []).map(opt => ({
        value: opt,
        label: opt,
      }));
      return [{ value: this.selectAllValue, label: 'Select All' }, ...options];
    },

    // Check if an option is selected
    isOptionSelected(key, value) {
      if (!this.filter[key]) return false;
      if (value === this.selectAllValue) {
        const allOptions = (this.listBoxOptions[key] || []).map(opt => opt);
        return allOptions.length > 0 && allOptions.every(opt =>
            this.filter[key].some(selected => selected.value === opt)
        );
      }
      return this.filter[key].some(opt => opt.value === value);
    },
    // Handle checkbox change
    handleCheckboxChange(key, value, event) {
      const isChecked = event.target.checked;
      let currentSelection = this.filter[key] ? [...this.filter[key]] : [];

      if (value === this.selectAllValue) {
        if (isChecked) {
          // Select all options
          currentSelection = (this.listBoxOptions[key] || []).map(opt => ({
            value: opt,
            label: opt,
          }));
        } else {
          // Deselect all options
          currentSelection = [];
        }
      } else {
        if (isChecked) {
          // Add the selected option
          if (!currentSelection.some(opt => opt.value === value)) {
            currentSelection.push({ value, label: value });
          }
        } else {
          // Remove the deselected option
          currentSelection = currentSelection.filter(opt => opt.value !== value);
        }
      }

      // Update the filter and trigger the multiselect update
      this.$set(this.filter, key, currentSelection);
      this.handleOptionSelected(key, currentSelection);
    },

    initializeDefaultSelections() {
      // console.log(" Initializing default selections...");

      if (this.screenletListboxDefault && Object.keys(this.screenletListboxDefault).length > 0) {

        Object.keys(this.screenletListboxDefault).forEach(key => {
          const defaultValue = this.screenletListboxDefault[key];

          if (defaultValue && this.listBoxOptions[key]) {

            let selectedOptions = [];

            // Handle array of default values
            if (Array.isArray(defaultValue)) {
              selectedOptions = defaultValue.map(value => ({
                value: value,
                label: value
              })).filter(opt =>
                  this.listBoxOptions[key].includes(opt.value)
              );
            }
            // Handle single default value
            else if (this.listBoxOptions[key].includes(defaultValue)) {
              selectedOptions = [{
                value: defaultValue,
                label: defaultValue
              }];
            }

            // Only set if we have valid selections
            if (selectedOptions.length > 0) {
              this.$set(this.filter, key, selectedOptions);
            } else {
              console.warn(` No valid selections found for '${key}' with default:`, defaultValue);
            }
          } else {
            console.warn(`No options available for '${key}' or invalid default value`);
          }
        });

        // console.log("Final filter object after initialization:", this.filter);
        this.handleSubmit();
      } else {
        this.toggleButton();
        // console.log("No defaults to initialize.");
      }
    },

    // Handle multiselect input
    handleOptionSelected(key, selected) {
      // Ensure selected is an array of objects
      // console.log("selected",selected)
      this.$set(this.filter, key, selected);
      this.$set(this.openDropdown, key, true)
      // this.$set(this.openDropdown, key, true)
      console.log("Filters",this.filter)
      const transformedFilter = this.transformFilter(this.filter);
      console.log(transformedFilter)
      this.optionSelected(transformedFilter);
    },

    onWindowResize() {
      const card = this.$refs.resizableCard;
      if (card) {
        const rect = card.getBoundingClientRect();

        console.log('Window resized → Card dimensions:', {
          width: rect.width,
          height: rect.height
        });
      }
    },
    startResize(e) {
      this.isResizing = true;
      const card = this.$refs.resizableCard;
      if (card) {
        const rect = card.getBoundingClientRect();
        this.startWidth = rect.width;
        this.startHeight = rect.height;
        this.startX = e.clientX;
        this.startY = e.clientY;

        document.addEventListener('mousemove', this.handleResize);
        document.addEventListener('mouseup', this.stopResize);
      }
      e.preventDefault();
    },

    handleResize(e) {
      if (!this.isResizing) return;

      const card = this.$refs.resizableCard;
      if (card) {
        // console.log("handleResize", card)
        const width = this.startWidth + (e.clientX - this.startX);
        const height = this.startHeight + (e.clientY - this.startY);

        card.style.width = `${width}px`;
        card.style.height = `${height}px`;
        this.cardWidth = width;
        this.cardHeight = height;
      }
    },

    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);
    },
    getFilterValue(key) {
      // Now handling both string keys (legacy) and object structure
      const filterKey = typeof key === 'object' ? key.name : key;
      return Array.isArray(this.filter[filterKey])
          ? this.filter[filterKey][0] || ''
          : this.filter[filterKey] || '';
    },

    updateFilter(key, value) {
      const filterKey = typeof key === 'object' ? key.name : key;
      if (value === null || value === '') {
        this.$delete(this.filter, filterKey);
      } else {
        this.$set(this.filter, filterKey, [value]);
      }
      if (this.menuPath === '/post-load') {
        this.toggleButton();
      } else {
        this.optionSelected(this.filter);
      }
    },
    async targetPage() {
      // console.log("Target page listener activated");

      // More comprehensive listener
      const messageHandler = (event) => {
        // console.log("Message received from:", event.origin);

        // Security check - adjust to your needs
        const allowedOrigins = [
          'http://localhost:7000',
          'https://forewarn.compegence.com',
          'https://fwdev.compegence.com',
          'https://bluestar360.compegence.com',
          'https://devbluestar360.compegence.com'
        ];

        if (!allowedOrigins.includes(event.origin)) {
          console.warn("Message from unauthorized origin:", event.origin);
          return;
        }

        if (event.data.type === 'FILTER_DATA') {  // Fixed typo
          // console.log('Received data:', {
          //   filters: event.data.payload.globalFilters,
          //   clickedData: event.data.payload.clickedData,
          //   source: event.data.payload.source
          // });
          this.globalFilters = event.data.payload.globalFilters;
          this.clickedFilters = event.data.payload.clickedData;
          // this.screenletListboxDefault = event.data.payload.globalFilters;
          // Apply filters to your page...
        } else {
          // console.log("Received unknown message type:", event.data.type);
        }
      };

      await window.addEventListener('message', messageHandler);

      // Cleanup (if using SPA framework)
      return () => {
        window.removeEventListener('message', messageHandler);
      };
    },
    transformFilter(filter) {
      const result = {...filter};

      for (const key in result) {
        const value = result[key];

        if (Array.isArray(value) && value.length > 0) {
          // Check if it's an array of objects with 'value' property
          const firstItem = value[0];
          if (firstItem && typeof firstItem === 'object' && 'value' in firstItem) {
            // Extract just the 'value' properties
            result[key] = value.map(item => item.value);
          }
        }
      }
      return result;
    },
    handleSubmit(itemName) {
      this.$set(this.openDropdown, itemName, false)
      // close the dropdown
      const ref = this.$refs[`multiselect-${itemName}`]
      if (ref && ref[0]) {
        ref[0].deactivate()
      }

      /*console.log("getDateConfigObject",this.getDateConfigObject())
      const DateConfig = this.getDateConfigObject();
      this.filter = {
        ...this.filter,
        DateConfig,
      };*/
      // Transform the filter first
      const transformedFilter = this.transformFilter(this.filter);
      console.log("transformedFilter",transformedFilter);

      console.log("filter ", JSON.stringify(transformedFilter, null, 2));
      this.$store.commit('setFilterFlag', true);
      this.submitSelectedFilter = this.$store.state.filterFlag;  // now read from state
      console.log("submitSelectedFilter", this.submitSelectedFilter);


      this.loadSummary(transformedFilter); // Pass the transformed filter
    },
    menuAnnonAccessControl(roleNameToCheck) {
      const userName = this.$store.state.userName;
      const roleName = this.$store.state.roleName; // Current user's role
      let submenuParam = this.$route.params.submenuId

      let menuMasterData = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam)
      // console.log("menuMasterData.menuAnnonUserRoleAccess", menuMasterData);

      const menuAnnonAccess = menuMasterData[0].menuAnnonUserRoleAccess;

      // Find the specific role object from the menuAnnonAccess array
      const accessConfig = menuAnnonAccess.find(access => access.annon_type === roleNameToCheck);

      if (!accessConfig) return false; // If role isn't found, deny access

      let hasUserAccess = accessConfig.users_allowed.includes(userName);
      let hasRoleAccess = accessConfig.roles_allowed.some(role => role === roleName);
      let roleBelongsToUser = !hasUserAccess && !hasRoleAccess && accessConfig.roles_allowed.includes(roleName);

      return hasUserAccess || hasRoleAccess || roleBelongsToUser;
    },
    closeEditor() {
      this.selectedType = '';
      this.errorMessage = '';
      this.isEditorOpen = false
    },
    getTooltipContent(message) {
      return `
        <div style="text-align: left">
            <strong>Type:</strong> ${message.annonType}<br>
            <strong>Added:</strong> ${message.createdBy} / ${message.createTimestamp}<br>
            <strong>Modified:</strong> ${message.updatedBy} / ${message.updateTimestamp}
        </div>
    `;
    },
    processAnnotations() {
      // console.log("canPerformFunctionality", this.canPerformFunctionality)
      // console.log("user and role", this.$store.state.userName, this.$store.state.roleName)
      let submenuParam = this.$route.params.submenuId
      let allVizData = this.$store.state.fwConfigScreenElement

      let screenTitleDpName;

      if (this.screenletId) {
        screenTitleDpName = allVizData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        screenTitleDpName = allVizData.filter(r => r.menuId === submenuParam)
      }
      // console.log("ScreenTitleDpName", screenTitleDpName);

      // console.log("store annotations", this.$store.state.annotations)
      const filterArray = this.$store.state.annotations.filter((item) => item.isBizAnnon && item.page === screenTitleDpName[0].screenletTitleDpName);
      // console.log("openCarousel is called", filterArray);

      const pressoNoteArray = filterArray
          .filter(item => item.annonType === "PresoNote")
          .sort((a, b) => new Date(b.updateTimestamp) - new Date(a.updateTimestamp));

      const userNoteArray = filterArray
          .filter(item => item.annonType === "UserNote" && item.userId === this.$store.state.user.userId)
          .sort((a, b) => new Date(b.updateTimestamp) - new Date(a.updateTimestamp));

      this.userAnnonCount = userNoteArray.length
      this.presoAnnonCount = pressoNoteArray.length
      // Combine both arrays ensuring "PressoNote" comes first
      this.messages = [...pressoNoteArray, ...userNoteArray];
    },
    openEditorToAdd() {
      // Open the editor for adding a new message
      this.editingIndex = null;
      this.editedMessage = ''; // Start with an empty message
      this.isEditorOpen = true;
    },
    startEditing(index, message) {
      this.editingIndex = index;
      this.editedMessage = message.annotation;
      this.isEditorOpen = true; // Open the editor
    },
    saveMessage(newContent) {
      // console.log("saveMessage method called")
      if (newContent) {
        let submenuParam = this.$route.params.submenuId
        let allVizData = this.$store.state.fwConfigScreenElement

        let screenTitleDpName;
        if (this.screenletId) {
          screenTitleDpName = allVizData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
        } else {
          screenTitleDpName = allVizData.filter(r => r.menuId === submenuParam)
        }

        if (this.editingIndex !== null) {
          // console.log("new content from screenlet", newContent);
          let messageObj = this.messages[this.editingIndex];
          // console.log("messageObj from save message method", messageObj);
          this.messages[this.editingIndex].annotation = newContent;
          const url = "/api/annotation/edit";
          const data = {
            id: messageObj.id,
            userId: 1,
            userName: "Admin",
            page: screenTitleDpName[0].screenletTitleDpName,
            section: screenTitleDpName[0].vizletTitleDpName,
            comment: newContent,
            isBizAnnon: true
          };
          const controller = apiAbort.new();  // 🔹 create abort controller

          try {
             axios.post(url, data, {
              signal: controller.signal,    // 🔹 attach abort signal
              headers: {
                'Content-Type': 'application/json'
              }
            });

            this.$store.dispatch("loadAnnotations");

          } catch (e) {
            if (e.code === 'ERR_CANCELED') {
              // console.log("updateAnnotations request canceled");
              return;  // do nothing on cancel
            }

            console.error("error in updating annotations", e);
          }
          this.editingIndex = null;
          this.isEditorOpen = false; // Open the editor
          this.closeCarousel();
        } else {
          // console.log("new annotation in else condition")
          if (this.selectedType) {
            // If adding a new message
            this.messages.push(newContent);
            const url = "/api/annotation";
            const data = {
              userId: 1,
              userName: "Admin",
              page: screenTitleDpName[0].screenletTitleDpName,
              section: screenTitleDpName[0].vizletTitleDpName,
              comment: newContent,
              isBizAnnon: true,
              annonType: this.selectedType,
            };
            // console.log("data from else condition", data);
            const controller = apiAbort.new();  // 🔹 create abort controller

            try {
               axios.post(url, data, {
                signal: controller.signal,    // 🔹 attach abort signal
                headers: {
                  'Content-Type': 'application/json'
                }
              });

              this.$store.dispatch("loadAnnotations");

            } catch (e) {
              if (e.code === 'ERR_CANCELED') {
                // console.log("updateAnnotations request canceled");
                return;  // do nothing on cancel
              }

              console.error("error in updating annotations", e);
            }
            this.errorMessage = '';
            this.selectedType = '';
            this.isEditorOpen = false; // Open the editor
            this.closeCarousel();
          } else {
            console.log("else condition in save message method")
            this.errorMessage = "Please select the note"
          }

        }
      }
    },
    enableBodyScroll() {
      document.body.classList.remove("modal-open"); // Remove BootstrapVue’s class
      document.body.style.overflow = "auto"; // Enable scrolling
    },
    restoreBodyScroll() {
      document.body.style.overflow = ""; // Reset to default
    },
    closeCarousel() {
      // console.log("Closing modal...");
      this.editingIndex = null; // Reset editing index
      this.editedMessage = ''; // Clear the edited message
      this.isOpenCoursel = false;
    },
    openCarousel() {
      // console.log("openCarousel is called");
      this.isOpenCoursel = !this.isOpenCoursel
    },
    updateToggle() {
      let submenuParam = this.$route.params.submenuId
      const config = this.$store.state.fwMClient[0]?.clientConfigParam?.dashboardDisplayConfig?.viewType;
      const roleConfig = this.$store.state.userRoleRestriction.roleConfigParam?.dashboardDisplayConfig?.viewType;
      const menuConfig = this.$store.state.menuMasterFlat.find(item => item.menuId === submenuParam)?.viewType;
      console.log(menuConfig)
      // Use roleConfig first, fallback to config if roleConfig is undefined/null
      const dashboardConfig = menuConfig ?? roleConfig ?? config;

      if (dashboardConfig) {
        this.isTabbedView = dashboardConfig === "Tab";
      }
      // console.log("update toggle functions executed");
      if (this.$store.state.filterType !== undefined) {
        this.isToggled = this.$store.state.filterType === "dialog-filter";
      } else if (this.$store.state.userRoleRestriction.filterType !== undefined) {
        this.isToggled = this.$store.state.userRoleRestriction.filterType === "dialog-filter";
      } else {
        this.isToggled = false;
      }
    },
    toggleButtonFunction() {
      this.isToggled = !this.isToggled;
      if(this.isToggled === false && !this.isAnyFilterSelected && this.menuPath === '/post-load' ){
          this.showError = true;
          return;
      }
    },
    onAlertDismissed() {
      this.showAlert = false; // Set showAlert to false when dismissed
      this.invalidMenuAlert = false
      this.showError = false
    },
    showFilterDialog() {
      this.$refs["dialog"].showModal()
      this.isDialogOpened = false
    },
    hideFilterDialog() {
      this.$refs["dialog"].close()
      this.isDialogOpened = true
    },

    showTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.show(); // Use the show method provided by Bootstrap-Vue
      }
    },
    hideTooltip() {
      const tooltip = this.$refs.tooltipIcon._tooltip;
      if (tooltip) {
        tooltip.hide(); // Use the hide method provided by Bootstrap-Vue
      }
    },
    makeFilter(rows, filterKeys) {
      //make distinct values of each col
      //total cols = 4

      let localFilters = Object.fromEntries(
          filterKeys.map(k => [k, new Set()])
      )
      for (let row of rows) {

        for (let fk of filterKeys) {
          localFilters[fk].add(row[fk])

        }

      }
      return Object.fromEntries(Object.entries(localFilters).map(x => {
        return [x[0], [...x[1]]]
      }))
    },
    async makeListBoxOptions() {
      let listboxData = this.dataset
      // console.clear()

      const makeOptions = (records, filterKeys, cacheKey) => {
        //make distinct values of each col
        //total cols = 4

        //cacheKey = simply, length of row + filterKeys

        const getDistinctColValues = () => {

          //for each key, we make a set to hold distinct values
          let localFilters = Object.fromEntries(
              filterKeys.map(k => [k, new Set()])
          )

          //parse through each record
          for (let row of records) {
            //for every filter-key, we add to set, this will de-dup the data
            for (let fk of filterKeys) {
              const value = row[fk];
              // Filter out null and undefined values
              if (value !== null && value !== undefined) {
                localFilters[fk].add(value);
              }
            }
          }

          //convert to a map of {k1: [distnct values for k1], k2: [distinct values for k2] .... etc}
          return Object.fromEntries(Object.entries(localFilters).map(x => {
            return [x[0], [...x[1]].sort()]
          }))
        }

        let fromCache = false; //this.listBoxCache[cacheKey]
        //let fromCache = false
        if (cacheKey && fromCache) {
          return fromCache;
        } else {
          // let ts = new Date().getTime()
          let value = getDistinctColValues();
          this.listBoxCache[cacheKey] = value;
          return value;

        }

      }

      const applyNextFilter = (currentFilter, restOfFilters, appliedFilters) => {

        let colSelected = currentFilter[0],
            colValues = currentFilter[1];

        //say 3 filters
        //salesman, brand, store
        //when nothing is selected, then distinct values of each can be used (default)
        //say one is selected, then we use that and select distinct values for rest
        //say two is selected, then use both to select distinct values for rest


        //filter records based on applied filters
        let listboxdataCopy = [...listboxData]

        for (let restFilter of restOfFilters) {
          if (restFilter[1].length > 0) {
            listboxdataCopy = listboxdataCopy.filter(x => restFilter[1].indexOf(x[restFilter[0]]) > -1);
          }
        }

        let optionsAfterRest = makeOptions(
            listboxdataCopy,
            [colSelected],
            [...Object.entries(restOfFilters), currentFilter].map(x => `${x[0]}:${x[1].join('-')}`).join()
        )

        //select records, by applying the current filter
        let recordsAfterFilter = listboxdataCopy.filter(x => colValues.indexOf(x[colSelected]) > -1);

        //from filters, remove the current filter, and previously applied filters
        let filterRemainingKeys = Object
            .keys(listboxData[0])
            .filter(x => x !== colSelected)
            .filter(x => !appliedFilters.map(y => y[0]).includes(x))

        //now we would have gotten, distinct col values for remaining filter, based on remaining data
        let options = makeOptions(
            recordsAfterFilter,
            filterRemainingKeys,
            Object.entries(this.filter).map(x => `${x[0]}:${x[1].join('-')}`).join()
        )
        return {...options, ...optionsAfterRest}
      }

      if (this.dataset.length > 0) {

        //if filter values are selected, then apply
        let initialFilterValues = makeOptions(listboxData, Object.keys(listboxData[0]), "ALL")
        let nextFilter = null;
        //iterate through each filter
        const transformedFilter = this.transformFilter(this.filter);
        let filterEntries = Object.entries(transformedFilter);
        let appliedFilters = []
        for (let currFilter of filterEntries) {

          let restOfFilters = filterEntries.filter(x => x[0] !== currFilter[0])

          //if the filter is selected
          if (currFilter[1].length > 0) {

            let prevFilter = {...(nextFilter || initialFilterValues)}
            let appliedFilter = applyNextFilter(
                currFilter,
                restOfFilters,
                appliedFilters
            )
            appliedFilters.push(currFilter)

            nextFilter = {...prevFilter, ...appliedFilter}
          }

          //else, skip this filter
        }
        return nextFilter || initialFilterValues

      } else {
        return {}

      }
    },
    async optionSelected() {
      //const transformedFilter = this.transformFilter(filter);
      this.listBoxOptions = await this.makeListBoxOptions();
     // this.$store.commit('setFilterFlag', true);
      this.sortDateRelatedObjects(this.listBoxOptions);
      console.log("this.listBoxOptions", this.listBoxOptions);
      if (this.menuPath === '/post-load') {
        await this.toggleButton();
      }
      if (this.isToggled === false && this.menuPath !== '/post-load') {
        await this.toggleButton();
      }
      return true;
    },
    resetLb: function () {
      console.log("reset function called")
      this.x = {}
      this.filter = {}
      if (this.menuPath !== '/post-load') {
        this.$nextTick(() => {
          this.handleSubmit()
        })
      }else{
        this.loadViz = false
        this.showError = true;
        return;
      }
    },
    toggleButton: async function () {
      let element = document.getElementById("button");
      element.classList.remove("btn-success")
      element.classList.add("btn-warning");
    },

    isDateRelated(value) {
      if (!value) return false;

      const fiscalYearPattern = /^\d{6}$/; // e.g., 202324
      const yearPattern = /^\d{4}$/; // e.g., 2023
      const fullDatePattern = /^\d{8}$/; // e.g., 20231115
      const dashDatePattern = /^\d{4}-\d{2}$/; // e.g., 2023-11
      const dashFullDatePattern = /^\d{4}-\d{2}-\d{2}$/; // e.g., 2023-11-15

      // Pattern for month names (e.g., Jan, January, etc.)
      const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

      return (
          fiscalYearPattern.test(value) ||
          yearPattern.test(value) ||
          fullDatePattern.test(value) ||
          dashDatePattern.test(value) ||
          dashFullDatePattern.test(value) ||
          monthPattern.test(value)
      );
    },

    parseDate(value) {
      if (!value) return 0;

      // Fiscal year format (YYYYMM)
      if (/^\d{6}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Year format (YYYY)
      if (/^\d{4}$/.test(value)) {
        return parseInt(value, 10);
      }

      // Full date format (YYYYMMDD)
      if (/^\d{8}$/.test(value)) {
        return new Date(
            parseInt(value.slice(0, 4), 10), // Year
            parseInt(value.slice(4, 6), 10) - 1, // Month (0-based)
            parseInt(value.slice(6, 8), 10) // Day
        ).getTime();
      }

      // Dash-separated year-month format (YYYY-MM)
      if (/^\d{4}-\d{2}$/.test(value)) {
        const [year, month] = value.split('-').map(Number);
        return new Date(year, month - 1, 1).getTime(); // First day of the month
      }

      // Dash-separated full date format (YYYY-MM-DD)
      if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        const [year, month, day] = value.split('-').map(Number);
        return new Date(year, month - 1, day).getTime();
      }

      // Month name (Jan, January, etc.)
      const monthMap = {
        jan: 0, january: 0,
        feb: 1, february: 1,
        mar: 2, march: 2,
        apr: 3, april: 3,
        may: 4,
        jun: 5, june: 5,
        jul: 6, july: 6,
        aug: 7, august: 7,
        sep: 8, september: 8,
        oct: 9, october: 9,
        nov: 10, november: 10,
        dec: 11, december: 11
      };

      const normalizedValue = value.trim().toLowerCase();
      for (const [key, month] of Object.entries(monthMap)) {
        // if (normalizedValue === key.toLowerCase()) {
        //   const currentYear = new Date().getFullYear();
        //   return new Date(currentYear, month, 1).getTime(); // Return timestamp for the first day of the month
        // }
        if (normalizedValue === key.toLowerCase()) {
          return month; // Return the numeric month index
        }
      }

      return 0; // Default for non-date-related values
    },


    fetchListboxData: async function (sqlId) {
      const controller = apiAbort.new()

      try {
        const res = await axios.get(`/api/fetchListboxData/${sqlId}`, {
          signal: controller.signal,
          headers: {
            'info-params': JSON.stringify({
              menuId: this.$route.params.menuId,
              submenuId: this.$route.params.submenuId
            }),
            'Content-Type': 'application/json'
          }
        })

        const removeEmptyOrNull = (obj) => {
          Object.keys(obj).forEach(k =>
              (obj[k] && typeof obj[k] === 'object' && removeEmptyOrNull(obj[k])) ||
              (!obj[k] && obj[k] !== undefined && delete obj[k])
          )
          return obj
        }

        let restrictedArray = this.$store.state.user.userRoleRestriction.menuAccessInclusionArray || []
        let exclusionArray = this.$store.state.user.userRoleRestriction.menuAccessExclusionArray || []

        const isAllMenusAllowed =
            !restrictedArray ||
            restrictedArray.length === 0 ||
            (restrictedArray.length === 1 && restrictedArray[0] === "[]")

        let data = this.$route.params.submenuId === "AB"
            ? res.data.filter(item => {
              if (isAllMenusAllowed) return true

              const isIncluded =
                  restrictedArray.includes(item.menu_id) ||
                  restrictedArray.includes(item.parent_menu_id)

              const isNotExcluded =
                  !exclusionArray.includes(item.menu_id) &&
                  !exclusionArray.includes(item.parent_menu_id)

              return isIncluded && isNotExcluded
            })
            : res.data

        let listboxData = data
        this.dataset = removeEmptyOrNull(listboxData)

        this.filter = Object.fromEntries(
            Object.keys(listboxData[0]).map(k => {
              return [k, []]
            })
        )
        // console.log("filter from fetch", listboxData)

        // ✅ only run this if request was NOT canceled
        this.listBoxOptions = await this.makeListBoxOptions()
        this.sortDateRelatedObjects(this.listBoxOptions)
      } catch (err) {
        // ✅ silently ignore canceled requests
        if (err.code === 'ERR_CANCELED') {
          // console.log('fetchListboxData canceled for', sqlId)
          return
        }

        // Other errors: rethrow or handle as you like
        console.error('fetchListboxData error', err)
        throw err
      }
    },


    loadListbox: async function () {

      let submenuParam = this.$route.params.submenuId
      // console.log("submenuParma", submenuParam);
      // await this.loadFilters();
      // await this.targetPage();
      await this.$store.dispatch("loadState")
      // this.screenName = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam).map(m => m.menuName)[0]
      let menuMasterData = this.$store.state.menuMasterFlat.filter(m => m.menuId === submenuParam)
      // console.log("menuMasterData", menuMasterData)
      if (menuMasterData.length === 0 && submenuParam) {
        this.invalidMenuAlert = true;
        setTimeout(() => {
          let url;

          const {homeDashboardMenuId} = this.$store.state.user;
          const roleLevelMenuId = this.$store.state.userRoleRestriction.homeDashboardMenuId;

          if (!homeDashboardMenuId) {
            url = roleLevelMenuId || '/';
            // console.log("Role level dashboard");
          } else {
            url = homeDashboardMenuId || '/';
            // console.log("User level dashboard");
          }

          if (!url.includes('/')) {
            // to do need to re-look this logic
            // (checking if it is just a menu id without / then re-direct to home page)
            url = '/'
          }
          this.$router.push(url)
        }, 5000);
      }
      this.menuPath = menuMasterData[0].menuPath

      let menuData = this.$store.state.fwConfigMenuScreenRender.filter(item => item.screenletTitleDpName !== "File Upload")
      // console.log("menuData", menuData);
      let columnMetadata = this.$store.state.colummnMetaData
      let actionIconsData = this.$store.state.actionIcons
      let listboxData = this.$store.state.listbox
      let currentMenuData = [];
      if (this.screenletId) {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        currentMenuData = menuData.filter(r => r.menuId === submenuParam)
      }

      this.screenName = currentMenuData[0]?.screenletTitleDpName

      //screenlet title info
      this.screenletTitleInfo = currentMenuData[0]?.screenletTitleInfo


      let screenletActionIconsSyspkArray = currentMenuData[0]?.screenletActionIconsSyspkArray ? currentMenuData[0]?.screenletActionIconsSyspkArray : []
      //let screenletListboxSyspkArray = currentMenuData[0].screenletListboxSyspkArray
      let screenletListboxSyspkArray = currentMenuData[0]?.screenletListboxSyspkArray ? currentMenuData[0]?.screenletListboxSyspkArray : []
      let currentMenuActionIconsData = actionIconsData.filter(r => screenletActionIconsSyspkArray.includes(r.syspk))
      let currentMenuListboxData = listboxData.filter(r => screenletListboxSyspkArray.includes(r.syspk))

      this.screenletListboxDefault = currentMenuData[0]?.screenletListboxDefaultValue
      this.screenletCardStyle = currentMenuData[0]?.screenletCardStyle


      function sortFuncLB(a, b) {

        return screenletListboxSyspkArray.indexOf(a.syspk) - screenletListboxSyspkArray.indexOf(b.syspk);
      }

      function sortFuncAI(a, b) {

        return screenletActionIconsSyspkArray.indexOf(a.syspk) - screenletActionIconsSyspkArray.indexOf(b.syspk);
      }

      currentMenuListboxData.sort(sortFuncLB); //sorting the currentMenuListboxData
      currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData

      this.currentMenuActionIconsData = currentMenuActionIconsData //need to add in router function
      this.currentMenuListboxData = currentMenuListboxData
      this.screenletListboxCount = currentMenuListboxData.length
      this.dateRangeFilterFlag = currentMenuData[0]?.dateRangeFilterDisplayFlag
      this.dateRangeFilterShortcuts = currentMenuData[0]?.dateRangeFilterShortcuts
      this.dateRangeDateField = Array.isArray(
          currentMenuData?.[0]?.dateRangeFilterConfig?.date_field
      )
          ? currentMenuData[0].dateRangeFilterConfig.date_field
          : [];
      this.dateRangeDateFieldLable =
          currentMenuData?.[0]?.dateRangeFilterConfig?.date_field?.[0]?.label || '';

      this.orderbyTextJson = currentMenuData[0]?.orderbyTextJson
      let currentMenuListboxSQLId = currentMenuData[0]?.screenletListbox1_sqlId
      this.screenletListboxType = currentMenuData[0]?.screenletListboxType
      if (currentMenuListboxSQLId) {
        await this.fetchListboxData(currentMenuListboxSQLId);
      }


      function dateRangeCalc(date1, interval, dateType) {
        switch (dateType) {
          case 'month': {
            let firstDay = new Date(date1.getFullYear(), date1.getMonth() - interval, 1);
            let lastDay = new Date(date1.getFullYear(), date1.getMonth(), 0);
            return [firstDay, lastDay];
          }
          case 'day': {
            let firstDay = new Date();
            let dateOffset = (24 * 60 * 60 * 1000) * interval; //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
          case 'hour': {
            let firstDay = new Date();
            let dateOffset = (interval * 60 * 60 * 1000); //5 days
            let lastDay = new Date();
            firstDay.setTime(firstDay.getTime() - dateOffset);
            lastDay.setTime(lastDay.getTime());
            return [firstDay, lastDay];
          }
        }
      }

      //let shortcuts = []
      for (let key in this.dateRangeFilterShortcuts) {
        const value = this.dateRangeFilterShortcuts[key];

        for (let inKey in value) {
          this.shortcuts.push({
            text: key,
            onClick: () => {
              const range = dateRangeCalc(new Date(), value[inKey], inKey);

              // update v-model manually
              this.time3 = range;

              // wait for model update, then submit
              this.$nextTick(() => {
                this.handleSubmit();
              });

              return range; // required by date-picker
            },
          });
        }
      }
      this.isInputFeildFlag = false
      currentMenuListboxData.forEach((cmld, index) => {
        // console.log("cmld", cmld);
        let bizNamefilterdim = columnMetadata.filter(c => c.columnName === cmld.listboxDimName);

        console.log("inputField",cmld.inputField)
        this.$set(this.screenletListboxDim, index, {
          name: cmld.listboxDimName,  // The key name you were using before
          isInputField: cmld.inputField  // The new input_field boolean
        });
        // Log the newly added item
        // console.log('Added item:', {
        //   index: index,
        //   name: cmld.listboxDimName,
        //   isInputField: cmld.inputField
        // });

// Log the entire array
        // console.log('Current screenletListboxDim:', JSON.parse(JSON.stringify(this.screenletListboxDim)));

        this.$set(this.SLlistboxDimBizName, index, bizNamefilterdim[0]?.bizName || null);
        //If any input field exists, set flag to true
        if (cmld.inputField === true) {
          this.isInputFeildFlag = true
        }
      });

      this.filter = {...this.applyScreenletListboxDefault}

      this.updateToggle();
      if(this.$store.state.deviceType==='Mobile'){
        this.isToggled = true
      }
      this.processAnnotations();
      this.initializeDefaultSelections();

      if (this.menuPath !== '/post-load') {
        // let timeOut =Object.keys(this.globalFilters).length>0?5000:2
        setTimeout(async () => {
          if(this.passedParam &&
              typeof this.passedParam === 'object' && Object.keys(this.passedParam).length>0){
            await this.loadSummary(this.passedParam)
          }else {
            this.handleSubmit();
          }
        }, 1000)
      }

      if (this.menuPath === '/post-load') {
        if (this.isToggled) {
          this.showAlert = true
          this.showFilterDialog();
        }
      }


    },

    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? !this.reverse : false;
      this.sortKey = sortKey;
    },
    filteredList() {
      return this.salesmanReportData.filter(report => {
        return report.salesman.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    makeWidth: function (r, c) {
      let v0 = this.vizDataRowCol[r][c][0].vizunitWidthArray
      let defV = ['2', '4', '5']
      let v = v0 && v0.length > 0 ? v0 : defV
      let lg = v[2]
      let w = ""
      let isMobile = window.innerWidth < 400
      if (isMobile) w = `width: 100%`
      else w = `width: ${lg * 10 - 5}%`
      return w
    },
    loadSummary: async function (x) {
      // console.log("filterType", this.$store.state.filterType);
      console.log("filter type", x);
      this.hideFilterDialog();
      this.vizFilterParams = _.cloneDeep(JSON.parse(JSON.stringify(this.getDateConfigObject())));

      console.log("vizFilterParams",JSON.stringify(this.filter))
      this.selectedOption = _.cloneDeep(this.filter)
      // CLEAR all listbox error borders
      this.listboxError = {}

      if (!this.isAnyFilterSelected) {
        if (this.menuPath === '/post-load') {
          this.showError = true;
          return;
        }
      }

      this.showError = false;


      //toggle button color when submitting
      if (document.getElementById("button")) {
        let element = document.getElementById("button");
        element.classList.remove("btn-warning")
        element.classList.add("btn-success");

      }

      this.propTime = new Date();
      this.loadViz = true
      let submenuParam = this.$route.params.submenuId

      await this.$store.dispatch("loadState")
      let allVizData = this.$store.state.fwConfigScreenElement

      if (this.screenletId) {
        this.vizDataRowCol[this.screenlet] = allVizData.filter(r => r.menuId === submenuParam && r.screenletInstanceId === this.screenletId)
      } else {
        this.vizDataRowCol[this.screenlet] = allVizData.filter(r => r.menuId === submenuParam)
      }


      if (this.vizDataRowCol[this.screenlet].length === 0) {
        return
      }

      let menuParam = this.$route.params.menuId

      this.menuName = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam).map(m => m.menuName)[0]
      this.menusyspk = this.$store.state.menuMasterFlat.filter(m => m.menuId === menuParam).map(m => m.syspk)[0]


      // x['fromDate'] = [this.time3[0]]
      // x['toDate'] = [this.time3[1]]
      this.$store.commit('setLBwhereCond', {k: this.screenlet, v: _.extend({}, x, this.sl)})
      for (let i = 0; i < this.vizDataRowCol[this.screenlet].length; i++) {

        this.vizDataRowCol[this.screenlet][i]['f'] = _.extend({}, x, this.sl)
        // this.vizDataRowCol[this.screenlet][i]['f']['fromDate'] = [this.time3[0]]
        // this.vizDataRowCol[this.screenlet][i]['f']['toDate'] = [this.time3[1]]
        // this.vizDataRowCol[this.screenlet][i]['fromDate'] = this.time3[0] //work around
        // this.vizDataRowCol[this.screenlet][i]['toDate'] = this.time3[1] //work around

      }
      let maxRows = this.vizDataRowCol[this.screenlet].length
      this.rows = _.range(0, maxRows)
      // console.log("syspk", this.menusyspk,this.vizDataRowCol[this.screenlet][this.rows[this.activeTab]])
      await this.$commonFn.auditLog(this.menusyspk, submenuParam, this.menuName, this.screenName, "GET", "Success", this.$store.state.deviceType)
      // let dateFilter = {"d4l1_date": this.time3[0]}
    },

    getDateConfigObject() {
      const dateField = this.dateRangeDateField?.[0]?.value;

      if (!dateField) return {};

      return {
        DateConfig: {
          dateField: [dateField],     // array as required
          dateRange: {
            fromDate: this.time3?.[0], // single value, not array
            toDate: this.time3?.[1],
          },
        },
      };
    },



    listenToRouter: function () {
      // console.log("listenToRouter is called")
      let $this = this
      this.$router.afterEach(function (from, to) {
        console.log(`router moved to ${from.path} from ${to.path}`)
        apiAbort.cancel();
        $this.rows = []
        $this.screenletListboxDim = {}
        $this.screenletListboxCount = null
        $this.screenletListboxDefault = {}
        $this.optionValues = []
        $this.isOpenCoursel = false
        $this.messages = []
        //$this.x = {"d3l1_name":"All","d6l1_name":"All"},//need to revisit to make it dynamic
        $this.x = {}//revisited and made dynamic
        $this.y = {}
        $this.filter = {}
        $this.time3 = ''
        $this.activeTab = 0
        $this.isTabbedView = false
        $this.$store.commit('setLBwhereCond',{})

        setTimeout(() => {
          if (from.matched.some(record => record.meta.requiresScreenConfig)) {
            // console.log("inside if condition", from.matched)
            $this.loadListbox()
          }
          // $this.loadSummary($this.x)
        }, 300)

      })
    },
    sortDateRelatedObjects(listBoxOptions) {
      // Clone the object to avoid mutating the original
      const sortedOptions = {...listBoxOptions};

      for (const key in sortedOptions) {
        const values = sortedOptions[key];
        if (Array.isArray(values)) {
          // Sort date-related values in descending order
          sortedOptions[key] = values.sort((a, b) => {
            const isADate = this.isDateRelated(a);
            const isBDate = this.isDateRelated(b);

            // Both are date-related, sort by date in descending order
            if (isADate && isBDate) {
              return this.parseDate(b) - this.parseDate(a);
            }

            // if (!this.isDateRelated(a) || !this.isDateRelated(b)) return 0;

            const monthPattern = /^(jan(uary)?|feb(ruary)?|mar(ch)?|apr(il)?|may|jun(e)?|jul(y)?|aug(ust)?|sep(tember)?|oct(ober)?|nov(ember)?|dec(ember)?)$/i;

            // Special case: Month names (case insensitive)
            if (monthPattern.test(a) && monthPattern.test(b)) {
              const monthOrder = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
              const aNormalized = a.slice(0, 3).toLowerCase(); // Normalize to lowercase
              const bNormalized = b.slice(0, 3).toLowerCase();
              return monthOrder.indexOf(bNormalized) - monthOrder.indexOf(aNormalized);
            }

            // One is date-related and the other is not
            if (isADate) {
              return -1; // Move date-related items to the front
            }

            if (isBDate) {
              return 1; // Move date-related items to the front
            }

            // Both are not date-related, sort alphabetically or numerically
            if (typeof a === 'string' && typeof b === 'string') {
              return a.localeCompare(b); // Ascending order for strings
            } else if (typeof a === 'number' && typeof b === 'number') {
              return a - b; // Ascending order for numbers
            }

            // Handle mixed data types (string vs number)
            return (typeof a < typeof b) ? -1 : 1; // Strings before numbers
          });
        }
      }

      return sortedOptions;
    }
  },

  beforeDestroy() {
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
    window.removeEventListener('resize', this.onWindowResize);

  },
}
</script>
<style scope>
.viz-tabs-container {
  width: 100%;
  height: 100%;
}

.tab-headers {
  display: flex;
  border-bottom: 1px solid #ccc;
  background-color: #f5f5f5;
  padding: 0 5px;
}

.tab-header {
  cursor: pointer;
  border: 1px solid #c3c0c0;
  border-bottom: none;
  margin-right: 2px;
  border-radius: 5px;
  background-color: #e0e0e0;
  transition: all 0.2s ease;
  min-width: 50px;
  flex-shrink: 0;
  /* text-align: center;*/
}

.tab-header:hover {
  background-color: #d0d0d0;
}

.tab-header.active {
  background-color: #5e8ef4;
  color: #ffffff;
  border-color: #5e8ef4;
  box-shadow: 0 -2px 6px rgba(37, 99, 235, 0.35);
  border-bottom: 1px solid white;
  margin-bottom: -1px;
  font-weight: bold;
}

/* Optional: active text slightly bolder */
.tab-header.active span {
  font-weight: 600;
}

dialog {
  width: 66vw;
  height: 66vh;
  margin: auto;
  border: 0 none;
  border-radius: 10px;
  padding: 2em;
  position: relative;
  z-index: 1000;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 20%);
}

.card-body {
  padding: 0;
  overflow: hidden;
}

.banner-true {
  height: 86vh;
  @media (max-width: 1300px) {
    max-height: 84vh;
  }
}

.banner-false {
  height: 93vh;
  @media (max-width: 1300px) {
    height: 92vh;
  }
}

.card-body .card-deck .card {
  margin: 0 !important;
}

.cScroll {
  height: 500px;
  overflow: scroll
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border: 1px solid black
}

.fixed-screen-width {
  @media (min-width: 576px) {
    width: 55vw;
  }
}


.my-custom-tooltip {
  background-color: transparent !important; /* Semi-transparent background */
  padding: 15px !important; /* Increased padding for better spacing */
  border: none !important;
  box-shadow: none !important; /* Subtle shadow for depth */
}

.my-custom-tooltip .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1200px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}

.multiselect__content-wrapper {
  top: 100% !important; /* Force dropdown to open below the input */
  bottom: auto !important; /* Prevent it from opening upwards */
  max-height: 200px; /* Limit height to prevent overflow issues */
  overflow-y: auto; /* Enable scrolling for long lists */
}


.anyWhichWay {
  background: #c7f0c3; /* #89fb85  daf0d9 */
}

.freeForm {
  background: #91bbf0;
}

.h1tag {
  font-size: 20px;
  margin-bottom: 0px;
}

.lists {
  margin-top: 0px;
}


@media (max-width: 1500px) and (min-width: 1301px) {
  .my-custom-tooltip .tooltip-inner {
    width: 950px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1300px) and (min-width: 1251px) {
  .my-custom-tooltip .tooltip-inner {
    width: 920px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1250px) and (min-width: 1201px) {
  .my-custom-tooltip .tooltip-inner {
    width: 870px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1200px) and (min-width: 1151px) {
  .my-custom-tooltip .tooltip-inner {
    width: 820px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1150px) and (min-width: 1101px) {
  .my-custom-tooltip .tooltip-inner {
    width: 770px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1100px) and (min-width: 1051px) {
  .my-custom-tooltip .tooltip-inner {
    width: 720px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 1050px) and (min-width: 1001px) {
  .my-custom-tooltip .tooltip-inner {
    width: 670px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}


@media (max-width: 1000px) and (min-width: 951px) {
  .my-custom-tooltip .tooltip-inner {
    width: 620px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 950px) and (min-width: 901px) {
  .my-custom-tooltip .tooltip-inner {
    width: 570px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 900px) and (min-width: 851px) {
  .my-custom-tooltip .tooltip-inner {
    width: 520px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 850px) and (min-width: 801px) {
  .my-custom-tooltip .tooltip-inner {
    width: 470px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .my-custom-tooltip .tooltip-inner {
    width: 430px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }


}


@media (max-width: 768px) and (min-width: 751px) {
  .my-custom-tooltip .tooltip-inner {
    width: 650px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 750px) and (min-width: 701px) {
  .my-custom-tooltip .tooltip-inner {
    width: 600px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 700px) and (min-width: 651px) {
  .my-custom-tooltip .tooltip-inner {
    width: 550px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 650px) and (min-width: 601px) {
  .my-custom-tooltip .tooltip-inner {
    width: 500px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 600px) and (min-width: 551px) {
  .my-custom-tooltip .tooltip-inner {
    width: 450px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 550px) and (min-width: 481px) {
  .my-custom-tooltip .tooltip-inner {
    width: 370px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }

}

@media (max-width: 480px) {
  .my-custom-tooltip .tooltip-inner {
    width: 350px; /* Further reduce the width for very small screens */
    font-size: 16px; /* Further adjust font size for very small screens */
  }

  .h1tag {
    font-size: 18px;
  }

}

.position-relative {
  position: relative;
  cursor: pointer;
}

.count-circle {
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  color: white;
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* First count - positioned slightly to the top right */
.count-1 {
  background-color: lightseagreen;
  top: -2px;
  right: 2px;
}

/* Second count - positioned slightly below the first */
.count-2 {
  background-color: #bec7de;
  top: -2px;
  right: -12px;
}


#carousel-1 .carousel-control-prev,
#carousel-1 .carousel-control-next {
  z-index: 100 !important; /* Ensures controls appear above text */
  width: 5%; /* Adjust width for better clickability */
}

.carousel-slide-content {
  position: relative;
  text-align: left; /* Aligns text to the left */
  max-width: 95%; /* Adjust width as needed */
  word-wrap: break-word;
  white-space: normal;
  margin: auto;
  padding: 20px;
  z-index: 1; /* Ensures text stays below the controls */
}

.edit-icon {
  position: absolute;
  right: 75px;
  cursor: pointer;
  color: #555; /* Adjust color */
  font-size: 10px;
}

.add-icon {
  position: absolute;
  right: 50px;
  cursor: pointer;
  color: #555; /* Adjust color */
  font-size: 10px;
}

.info-icon {
  position: absolute;
  right: 100px;
  cursor: pointer;
  color: #555; /* Adjust color */
  font-size: 10px;
}

#carouselModal {
  position: fixed; /* Use fixed positioning */
  top: 0; /* Align to the top */
  left: 0; /* Align to the right */
  width: 80%; /* Width that responds to the viewport */
  max-width: 1300px; /* Max width for larger screens */
  height: auto; /* Allow height to adjust */
  margin: 0; /* Remove default margin */
  z-index: 1000; /* Ensure it's above other elements */
}

@media (max-width: 768px) {
  #carouselModal {
    width: 95%; /* Full width for smaller screens */
    right: 2.5%; /* Center it a bit with a small padding */
  }
}

.close-cancel-btn {
  position: absolute; /* Positions the button */
  top: -5px; /* Adjusts the top position */
  right: 10px; /* Adjusts the right position */
  border: none; /* Removes default button styling */
  background: transparent; /* Makes the background transparent */
  font-size: small; /* Size of the X icon */
  color: #000; /* Color of the button */
  cursor: pointer; /* Changes cursor to pointer on hover */
}

#carousel-1 .carousel-indicators {
  top: -5px;
  position: absolute;
  display: flex;
  gap: 5px; /* Space between dots */
}

#carousel-1 .carousel-indicators li {
  width: 8px; /* Small dot size */
  height: 8px;
  background-color: black; /* Change dot color */
  border-radius: 50%; /* Make it round */
  opacity: 0.5;
  transition: opacity 0.3s ease-in-out;
}

#carousel-1 .carousel-indicators .active {
  opacity: 1;
  background-color: blue; /* Highlight active dot */
}

.disabled-label {
  cursor: not-allowed; /* Changes cursor for the label */
}

.input-feild {
  min-height: 40px;
  display: block;
  padding: 10px 2px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 14px;
  text-align: center;
  outline: none;
}

.input-feild::placeholder {
  font-weight: 300; /* Thin placeholder */
  color: #aaa; /* Optional: lighter color */
}

.form-control::placeholder {
  font-weight: 300;
  color: #aaa;
  font-size: 14px;

}

.flex-row-overflowX-style {
  overflow-y: auto;
  overflow-x: auto;
  max-height: 100%;
}

.body-div {
  height: 100%;
}

.flex-row-overflowY-style {
  overflow: auto;
  max-height: 500px;
}

@media (max-height: 920px) {

  .flex-row-overflowY-style {
    max-height: 400px;
  }
}

@media (max-height: 560px) {

  .flex-row-overflowY-style {
    max-height: 250px;
  }
}

.resizable-card {
  position: relative;
  display: flex;
  flex-direction: column;
}

.resize-handle {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 20px;
  height: 20px;
  background: #fffefe;
  cursor: se-resize;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 4px;
  user-select: none;
  font-weight: 800;

  /* ensures it stays on top */
  z-index: 9999;

}

.custom-option {
  width: 100%;
  cursor: pointer;
  pointer-events: auto;

}

.custom-option.disable-parent-click {
  pointer-events: none;
  width: 100%;
}

.custom-option.disable-parent-click input {
  pointer-events: auto;
}

.custom-option input {
  pointer-events: auto;
}

.multiselect-footer {
  position: sticky;
  bottom: 0;
  background: #fff;
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
  border-top: 1px solid #ddd;
  z-index: 10;

  .okay {
    background-color: #218838;
  }
}

.custom-option input{
  cursor: pointer;
}

.header-left-row {
  display: flex;
  align-items: center;
  white-space: nowrap;
  margin-right: 5px;
}

.compact-multiselect {
  font-size: 14px;
}

.compact-multiselect .multiselect__tags {
  min-height: 20px;
  padding: 4px 40px 0 8px;
}

.compact-multiselect .multiselect__select {
  min-height: 20px;
  padding: 0 0 7px 2px;
}

/*.compact-multiselect .multiselect__single {
  padding: 4px 0;
  margin: 0;
}*/

/*.compact-multiselect .multiselect__option {
  padding: 1px 2px;
  min-height: 20px;
}*/

/*
.compact-multiselect .multiselect__option--highlight {
  background: #f3f3f3;
}

.compact-multiselect .multiselect__option--selected {
  background: #e8f4ff;
}
*/

/*.compact-multiselect .custom-option {
  display: flex;
  align-items: center;
  padding: 2px 8px;
  min-height: 24px;
}

.compact-multiselect .custom-option input[type="checkbox"] {
  margin-right: 6px;
  transform: scale(0.85);
}*/

.compact-multiselect .multiselect-footer {
  padding: 6px 8px;
}

.compact-multiselect .multiselect-footer button {
  padding: 3px 8px;
  font-size: 16px;
  height: 28px;
  line-height: 1;
}
.date-picker-card{
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  .mx-datepicker-range{
    width: 200px;
    border-radius: 5px;
    border:1px solid #e8e8e8
  }
}

.date-picker-dialog-card{
  display: flex;
  flex-direction: column;
  line-height: 1.4;
  p{
    font-size: 0.8rem;
    font-weight: bold;
    text-align: left !important
  }

   .mx-datepicker-range{
    width: 100%;
  }

}

.mx-datepicker-range:hover{
  border: none;
}

.mx-input-wrapper .mx-input{
  padding: 20.5px 5px;
}

.mx-datepicker-btn-confirm{
  background-color: #28a745;
  color: #fff;
}

.mx-datepicker-btn-confirm:hover {
  background-color: #0d9f2f;
  color: #fff;
}

.border-error .multiselect__tags {
  background-color: #f6f69b;
}

.multiselect__tag{
  color:black;
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
  background-color: #e9eaec;
  color: black;
}
</style>
